module.exports = __webpack_public_path__ + "img/PARIMATCH.c1cdf75b.svg";